import { Alert } from "@mui/material";
import * as React from "react";
import { useRouteError } from "react-router";

import { PageLayout } from "@/shared/components/PageLayout";
import { ErrorMonitoringService } from "@/shared/services";

import {
  InvalidWorkspaceConfigError,
  WorkspaceNotFoundError,
} from "../loader/exceptions";

/**
 * Top-most error boundary for the visualization workspace.
 *
 * Reference: https://reactrouter.com/en/main/route/error-element
 */
export function ErrorBoundary() {
  const error = useRouteError();
  const errorMessage = toErrorMessage(error);

  React.useEffect(() => {
    ErrorMonitoringService.captureError(error);
  }, [error]);

  return (
    <PageLayout title={"Roboto - Visualization"}>
      <div>
        <Alert severity="error">{errorMessage}</Alert>
      </div>
    </PageLayout>
  );
}

function toErrorMessage(error: unknown): string {
  if (
    error instanceof InvalidWorkspaceConfigError ||
    error instanceof WorkspaceNotFoundError
  ) {
    return error.message;
  }

  return "Something went wrong loading the visualization workspace. Please try reloading the page.";
}
